import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#5003AF',
      contrastText: '#ffff',
    },
    secondary: {
      main: '#D8690F',
      contrastText: '#ffff',
    },
    tertiary: {
      main: '#fff',
      contrastText: '#ffff',
    },
  },
});

export default theme;
